import { Text } from '@chakra-ui/react';
import { COPYRIGHT_TEXT } from '../utils/constants';

interface CopyrightTextProps {
  className?: string;
}

export const CopyrightText = ({ className }: CopyrightTextProps) => {
  return (
    <Text 
      textAlign="center" 
      fontSize="9px"
      color="rgba(255,255,255,0.45)"
      fontStyle="italic"
      mt={2}
      lineHeight="1.2"
      pb={2}
      className={className}
    >
      {COPYRIGHT_TEXT}
    </Text>
  );
}; 